/**
 * Stable CSS class names for E2E — User cargo package details.
 */
export const UCPD = {
    metaCard: 'order-detail-user-cargo-package-details__meta-card',
    metaContent: 'order-detail-user-cargo-package-details__meta-content',
    rowEstimatedShipDate: 'order-detail-user-cargo-package-details__row-estimated-ship-date',
    rowEstimatedRange: 'order-detail-user-cargo-package-details__row-estimated-date-range',
    rowLostPackage: 'order-detail-user-cargo-package-details__row-lost-package',
    inputLinkLostPackageOrder: 'order-detail-user-cargo-package-details-input--link-lost-package-order',
    lostPackageInvoicedMessage: 'order-detail-user-cargo-package-details__lost-package-invoiced-message',
    rowSellerStoreTracking: 'order-detail-user-cargo-package-details__row-seller-store-tracking',
    copyTrackingWrap: 'order-detail-user-cargo-package-details__copy-tracking-wrap',
    packagesCard: 'order-detail-user-cargo-package-details__packages-card',
    packagesContent: 'order-detail-user-cargo-package-details__packages-content',
    tableContainer: 'order-detail-user-cargo-package-details__table-container',
    table: 'order-detail-user-cargo-package-details__table',
    headRow: 'order-detail-user-cargo-package-details__head-row',
    headCellSum: 'order-detail-user-cargo-package-details__head-cell-sum',
    headCellDescription: 'order-detail-user-cargo-package-details__head-cell-description',
    headCellBarcode: 'order-detail-user-cargo-package-details__head-cell-barcode',
    headCellQty: 'order-detail-user-cargo-package-details__head-cell-qty',
    packageRow: 'order-detail-user-cargo-package-details__package-row',
    bodyCellSum: 'order-detail-user-cargo-package-details__body-cell-sum',
    bodyCellDescription: 'order-detail-user-cargo-package-details__body-cell-description',
    bodyCellBarcode: 'order-detail-user-cargo-package-details__body-cell-barcode',
    bodyCellQty: 'order-detail-user-cargo-package-details__body-cell-qty',
    loadingGrid: 'order-detail-user-cargo-package-details__loading-grid',
    loadingInner: 'order-detail-user-cargo-package-details__loading-inner',
    emptyState: 'order-detail-user-cargo-package-details__empty-state',
    emptyIcon: 'order-detail-user-cargo-package-details__empty-icon',
    emptyTitle: 'order-detail-user-cargo-package-details__empty-title',
} as const;

export const ucpdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
